import React, { useEffect, useState } from 'react';
import SettlementController from '../../controller/SettlementController';
import moment from 'moment';
import CustomCalender from '../../components/Calender';

const SalesCalendar = () => {
  const [salesData, setSalesData] = useState<any>({});
  const [selectDate, setSelectDate] = useState<string>('');

  const editCalendarData = async () => {
    try {
      if (moment(selectDate).isAfter(moment().format('YYYY-MM'))) {
        console.log('이후 날짜 입니다.');
        setSalesData({
          [selectDate]: {
            net_sales: 0,
            net_sales_cnt: 0,
          },
          total_amount: 0,
          total_cnt: 0,
        });
        return;
      }

      const oData = {
        month: selectDate,
      };

      const oResp = await SettlementController.getCalendarSettle(oData);
      let oResponse;
      console.log('oResp', oResp);
      if (oResp && oResp.data) {
        oResponse = oResp.data.data;
        setSalesData(oResponse);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // useEffect(() => {
  //   editCalendarData();
  // }, [selectDate]);

  return <CustomCalender sData={salesData} setSelectDate={setSelectDate} />;
};

export default SalesCalendar;
